<template>
  <!-- 离线配置修改点10 -->
  <div class="page forbit-cancel-tree">
    <Modal
      v-model="exportModal"
      class="page-modal"
      width="40%"
      :mask-closable="false"
      :footer-hide="true"
      :title="$t('updateNewSip.setSecret')"
      class-name="vertical-center-modal"
    >
      <div class="main-box margin-bottom-20">
        <div class="secret-box">
          <span>{{ $t("updateNewSip.secret") }}</span>
          <div class="secret-input">
            <Input
              v-model="secret"
              type="text"
              size="large"
              :placeholder="$t('updateNewSip.secretTip')"
              maxlength="32"
            >
            </Input>
            <h4>
              <Icon type="md-information-circle" ssize="30" color="#fc7790" />
              {{ $t("updateNewSip.noSecretTip") }}
            </h4>
          </div>
        </div>
        <div class="detailBackBtn">
          <Button type="default" size="large" @click="backBtn(0)">{{
            $t("updateNewSip.ignore")
          }}</Button>
          <Button type="primary" size="large" @click="backBtn(1)">{{
            $t("common.submit")
          }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "exportModal",
  components: {},
  data() {
    return {
      exportModal: false,
      secret: "",
      formateExportData: {}, // 格式化后的导出配置文件数据
    };
  },
  computed: {
    ...mapState("projectConfig", [
      "areaData",
      "areaDeviceData",
      "projectInfo",
      "fileVersion",
    ]),
  },
  watch: {
    exportModal: {
      handler() {
        if (!this.exportModal) {
          this.secret = "";
        }
      },
    },
  },
  mounted() {},
  methods: {
    // 忽略
    backBtn(type) {
      this.exportModal = false;
      this.exportAddrBook(type);
    },
    // 格式化提交数据
    formateData(a) {
      let _this = this;
      let submitData = a;
      submitData.forEach((item) => {
        // 设置树组件的唯一值
        item.treeNodeId = item.$treeNodeId;
        item.level = item.level ? item.level : _this.currentLevel;
        // 一层数据
        if (item.groupList) {
          // 设备
          item.devList = item.groupList.filter((i) => {
            if (i.funList) {
              return i;
            }
          });
          // 设置树组件的唯一值
          item.devList.forEach((devItem) => {
            devItem.treeNodeId = devItem.$treeNodeId;
          });
          // 区域
          item.groupList = item.groupList.filter((i) => {
            if (i.code) {
              return i;
            }
          });
          // 迭代
          if (Array.isArray(item.groupList) && item.groupList.length > 0) {
            _this.formateData(item.groupList);
          }
        }
      });
      submitData = JSON.parse(JSON.stringify(submitData));
      return submitData;
    },
    // 设置level的值
    formateLevel(a) {
      a.forEach((item) => {
        item.level = 1;
        if (item.groupList) {
          item.groupList.forEach((sitem) => {
            sitem.level = 2;

            if (sitem.groupList) {
              sitem.groupList.forEach((ssitem) => {
                ssitem.level = 3;

                if (ssitem.groupList) {
                  ssitem.groupList.forEach((sssitem) => {
                    sssitem.level = 4;

                    if (sssitem.groupList) {
                      sssitem.groupList.forEach((ssssitem) => {
                        ssssitem.level = 5;
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    },
    // 导出xml文件
    exportAddrBook(type) {
      // 隐藏属性 $treeNodeId
      let submitArray = this.areaDeviceData;

      this.formateData(submitArray);
      this.formateLevel(submitArray);

      // 清除首层设备
      let addressDeviceList = submitArray.filter((item) => item.isTopDevice);
      if (addressDeviceList.length > 0) {
        addressDeviceList = addressDeviceList[0].devList;
      }
      submitArray = submitArray.map((item) => {
        if (!item.isTopDevice) {
          return item;
        } else {
          return "";
        }
      });
      submitArray = submitArray.filter((item) => item); // 过滤空值
      let params = {
        addressDeviceList: addressDeviceList,
        addressGroupList: submitArray,
        fileVersion: {
          version: this.fileVersion,
        },
        project: this.projectInfo,
      };
      console.log("保存参数");
      console.log(JSON.stringify(params));
      if (type === 1) {
        params.secret = this.secret;
      }
      this.$store
        .dispatch("projectConfig/exportAddrBook", params)
        .then((response) => {
          const resData = response;
          this.$Message.success(this.$t("deviceSip.exportSuccess"));
          this.downLoadFile(resData);
        })
        .catch(() => {});
    },
    // 下载文件
    downLoadFile(file) {
      let fileName = this.projectInfo.name + ".zip";
      let blob = new Blob([file], {
        type: "application/zip",
      });
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(blob); // 创建下载的链接
      downloadElement.href = href;

      downloadElement.download = fileName; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
      this.$emit("updateTree");
    },
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  width: 100%;

  .right-box,
  .left-box {
    width: 100%;
    cursor: pointer;
    text-align: center;
  }
  .line {
    display: block;
    background: #efefef;
    height: 153px;
    width: 2px;
  }

  .upload-icon {
    font-size: 80px;
    display: block;
  }

  .btn-group {
    display: flex;
    justify-content: space-around;
    width: 40%;
    margin: 40px auto 0;
  }
}
.file {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: auto;
  height: auto;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.secret-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 50px;
  span {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-top: -15px;
  }
  div {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
  }
  .secret-input {
    width: 75%;
  }
}
</style>
